// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1VA87","alertIcon":"ConfirmModal_alertIcon__3ogV0"};